import axios from '@/utils/axios';

export function useAuth() {
  /*
    일반 로그인 API (bypass)
    usedComponent: "@/components/ui/sign/signinPassword.vue"
  */
  const signIn = async (payload: api.auth.signIn.payload) => {
    try {
      const { data } = await axios.post<api.auth.signIn.response>('/login', payload, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    네이버 로그인 API (bypass)
    usedComponent: "view/oauth/naver.vue"
  */
  const signInNaver = async (payload: api.auth.signInNaver.payload) => {
    try {
      const { data } = await axios.get<api.auth.signInNaver.response>(
        `/oauth/naver?code=${payload.code}&state=${payload.state}`,
        { headers: { 'X-bypass': true } }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    카카오 로그인 API (bypass)
    usedComponent: "view/oauth/kakao.vue"
  */
  const signInKakao = async (payload: api.auth.signInKakao.payload) => {
    try {
      const { data } = await axios.post<api.auth.signInKakao.response>(`/oauth/kakao`, payload, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
     이메일 중복 검증 API (bypass)
     used: "@/lib/useValidtor"
   */
  const checkDuplicateEmail = async (payload: api.auth.checkDuplicateEmail.payload) => {
    try {
      const { data } = await axios.post<api.auth.checkDuplicateEmail.response>('clients/email/check', payload, {
        headers: { 'X-bypass': true },
      });
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
     전화번호 중복 검증 API (bypass)
     used: "@/lib/useValidtor"
   */
  const checkDuplicatePhoneNumber = async (payload: api.auth.checkDuplicatePhoneNumber.payload) => {
    try {
      const { data } = await axios.post<api.auth.checkDuplicatePhoneNumber.response>(
        'clients/phone-number/check',
        payload,
        {
          headers: { 'X-bypass': true },
        }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    인증번호 발송 API - 회원가입용 ( 전제 : 등록된 전화번호가 아니어야 함. )
    payload : { phoneNumber: string }
    used: "@/component/ui/sign/signupDefault.vue"
  */
  const sendVerificationCode = async (payload: string) => {
    try {
      const { data } = await axios.post<api.auth.sendVerificationCode.response>(
        `codes/incoming/${payload}`,
        {},
        { headers: { 'X-bypass': true } }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    인증번호 발송 API - 아이디찾기용 (전화번호 전제 없음.)
  */
  const sendInsideVerificationCode = async (payload: api.auth.sendVerificationCode.payload) => {
    try {
      const { data } = await axios.post<api.auth.sendVerificationCode.response>(
        `codes/inside/${payload.phoneNumber}`,
        {
          token: payload.token,
        },
        { headers: { 'X-bypass': true } }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };
  /*
    인증번호 발송 API - 비밀번호찾기용 ( 전제 : 가입된 이메일-전화번호 매칭 되어야함 )
  */
  const sendVerifyCodeForPassword = async (payload: api.auth.sendVerificationCode.payload) => {
    try {
      const { data } = await axios.post<api.auth.sendVerificationCode.response>(
        '/codes/password-find',
        {
          reCaptchaToken: payload.token,
          email: payload.userId,
          phoneNumber: payload.phoneNumber,
        },
        { headers: { 'X-bypass': true } }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    인증번호 확인 API(bypass)
    used: "@/component/ui/sign/signupDefault.vue"
  */
  const checkVerificationCode = async (payload: api.auth.checkVerificationCode.payload) => {
    try {
      const { data } = await axios.post<api.auth.checkVerificationCode.response>('codes/verify', payload, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    일반회원 회원가입 API(bypass)
  */
  const registerUser = async (payload: api.auth.registerUser.payload) => {
    try {
      const { data } = await axios.post<api.auth.registerUser.response>('clients', payload, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    소셜(kakao,naver) 회원가입 API(bypass)
  */
  const registerOauthUser = async (payload: api.auth.registerOauthUser.payload) => {
    try {
      const { data } = await axios.post<api.auth.registerOauthUser.response>('clients/oauth', payload, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /*
    세션 유효성 조회
  */
  const sessionValidate = async (payload: string) => {
    try {
      const { data } = await axios.get<api.auth.sessionValidate.response>(`session/alive/${payload}`, {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 회원가입 타입 확인
   */
  const $checkJoinType = async (email: string) => {
    const { data } = await axios.post<api.auth.checkJoinType.response>(`clients/join-type`, { email: email });

    if (!data.success) throw data;
    return { ...data, email };
  };

  /**
   * sso등록 email 확인
   */
  const checkSSOEmail = async (email: string) => {
    try {
      const { data } = await axios.post<api.auth.ssoEmail.response>(
        `/oauth/sso`,
        {
          email: email,
        },
        {
          validateStatus: (status) => {
            return status < 500;
          },
        }
      );
      return data;
    } catch (e) {
      throw e;
    }
  };

  const SSOLogin = async (authCode: string, vendor: string) => {
    try {
      const { data } = await axios.post<api.auth.ssoLogin.response>(`/oauth/exchange`, {
        authCode: authCode,
        vendor: vendor,
      });

      // if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * SIFC - Token + 상태에 따라 로그인/약관동의 업데이트/에러페이지 Rending
   */
  const signActionByToken = async (payload: { token: string }) => {
    try {
      const { data } = await axios.post(`/auth/ifc`, payload);

      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  return {
    signIn,
    signInNaver,
    signInKakao,
    checkDuplicateEmail,
    checkDuplicatePhoneNumber,
    sendVerificationCode,
    sendInsideVerificationCode,
    sendVerifyCodeForPassword,
    checkVerificationCode,
    registerUser,
    registerOauthUser,
    sessionValidate,
    $checkJoinType,
    checkSSOEmail,
    SSOLogin,
    signActionByToken,
  };
}
